import { Box } from "@mui/material";
import React from "react";

import { Outlet } from "react-router-dom";

export default function MainLayout() {
  return (
    <Box
      id="main-layout"
      sx={{
        backgroundColor: "--var(--background-default)",
        maxWidth: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      className="bg-default"
    >
      <Outlet />
    </Box>
  );
}
